
import { React, useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import { TooltipComponent, TitleComponent } from "echarts/components";
import {
  getTime,
  getDate,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

function Sitestatus(props) {

  var yAxisData = [];

  const [echartInstance, setEchartInstance] = useState(null);

  const size = useWindowSize();

  if(props.yAxisData != undefined) {
    props.yAxisData.map((value) => {
      yAxisData.push(value === 0 ? '' : value)
    })
  }

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  echarts.use([TitleComponent, TooltipComponent, BarChart]);

  const options = () => ({
    tooltip: {
      // trigger: 'item'
    },
    title: {
      // text: 'Site Status',
    },
    legend: {
      show: false,
    },
    grid: {
      top: "5%",
      bottom: "37%",
      left: "15%",
    },
    xAxis: {
      type: "category",
      data: props.xAxisData,
      axisLabel: {
        rotate: 30,
      },
    },
    yAxis: {
      type: "value",
      name: "Count",
      nameLocation: "middle",
      nameGap: 30,

      axisLabel: {
        formatter: formatYaxisNumber,
      },
    },
    series: [
      {
        type: "bar",
        itemStyle: {
          borderColor: "transparent",
          color: "transparent",
        },
        emphasis: {
          itemStyle: {
            borderColor: "transparent",
            color: "transparent",
          },
        },
        data: props.yAxisData,
      },
      {
        type: "bar",
        showBackground: true,
        backgroundStyle: {
          color: "transparent",
        },
        label: {
          show: true,
          position: "top",
        },
        color: "#AD0A74",
        data: yAxisData,
      },
    ],
  });

  return (
    <ReactECharts
      echarts={echarts}
      // notMerge={true}
      // lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      opts={{ renderer: "svg" }}
      option={options()}
    />
  );
}
export default Sitestatus;
